// extracted by mini-css-extract-plugin
module.exports = {"pill":"ScheduleStatusPill_pill__1G8IO","active":"ScheduleStatusPill_active__2_VFl","paused":"ScheduleStatusPill_paused__2cHLa","error":"ScheduleStatusPill_error__894XM"};